import styled, { css } from "styled-components";
import { TableCell } from "@mui/material";
import { ReactNode } from "react";

type UserRightsTableCellProps = {
  isHeader?: boolean;
  width?: string | number;
  textAlign?: "left" | "center";
  children: ReactNode;
};

const StyledTableCell = styled(TableCell)<UserRightsTableCellProps>`
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  text-align: ${(props) => props.textAlign};
  width: ${(props) => props.width};
  ${(props) =>
    props.isHeader &&
    css`
      font-weight: 700;
    `};
`;

export const UserRightsTableCell = ({
  isHeader = false,
  width = "auto",
  textAlign = "center",
  children,
}: UserRightsTableCellProps) => {
  return (
    <StyledTableCell isHeader={isHeader} width={width} textAlign={textAlign}>
      {children}
    </StyledTableCell>
  );
};
